import Header from "@/atomic/atoms/Header";
import { PropsView } from "./Models";
import Button from "@/atomic/atoms/Button";

export default function ForgotPasswordView({
  goBack,
  customer,
  onChange,
  onPaste,
  goToPin,
  isDisabled,
}: PropsView) {
  return (
    <div className="h-full">
      <Header title="Esqueci minha senha" hasLeftButton goBack={goBack} />
      <main className="p-2 w-full flex justify-center h-[calc(100%-72px)] h-form">
        <article className="h-full flex flex-col justify-between w-[calc(480px)]">
          <div>
            <h2 className="mt-6 text-black text-xl">Validar acesso</h2>
            <h3 className="text-black text-sm">
              Precisamos validar seus dados de acesso, informe abaixo seu CPF ou
              CNPJ.
            </h3>
            <div className="flex flex-col justify-center items-center">
              <input
                value={customer?.forgot?.document ?? ""}
                name="document"
                required
                onChange={onChange}
                onPaste={onPaste}
                type="text"
                inputMode="numeric"
                maxLength={18}
                placeholder="CPF/CNPJ"
                className="mt-5 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
            </div>
          </div>
          <Button
            title="Avançar"
            className="w-full mt-4 h-[60px] text-white font-secondary text-base tracking-tight px-5 py-4 rounded-theme-medium transition-opacity bg-primary hover:opacity-95"
            onClick={goToPin}
            type="submit"
            isDisabled={isDisabled}
          />
        </article>
      </main>
    </div>
  );
}
